import React, { useState } from 'react'
import { showMessageBox } from '../../../../../store/actions/system.actions'
import { errorHandler } from '../../../../../services/util/error.service'
import { Btn, BtnIcon } from '../../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../assets/js/styles'

import { FaEdit } from 'react-icons/fa'
import ModalNovaSobra from './ModalNovaSobra'
import ModalAjusteSobra from './ModalAjusteSobra'
import { formatSobraQuantity } from './sobra-volume-and-units.helper'

export default function SobrasDataTable({
  ocorrencias,
  setOcorrencias,
  getOcorrenciaSobras,
  dispatch,
  fleetId,
  vehicleBadge,
}) {
  const [showModalAjusteSobra, setShowModalAjusteSobra] = useState(false)
  const [showModalNovaOcorrencia, setShowModalNovaOcorrencia] = useState(false)
  const [selectedOcorrencia, setSelectedOcorrencia] = useState(null)

  const onModalAjusteSobraClose = () => {
    setShowModalAjusteSobra(false)
  }

  const onModalAjusteSobraSuccess = ocorrencia => {
    const { leftover_id } = ocorrencia
    const index = ocorrencias.findIndex(o => o.leftover_id === leftover_id)

    if (index !== -1) {
      const o = [...ocorrencias]
      o[index] = ocorrencia
      setOcorrencias(o)
    }
    setShowModalAjusteSobra(false)
  }

  const onModalNovaOcorrenciaSuccess = async () => {
    await getOcorrenciaSobras()
    setShowModalNovaOcorrencia(false)
  }

  const onModalError = error => {
    dispatch(showMessageBox(null, errorHandler(error)))
  }

  const onModalNovaOcorrenciaClose = () => {
    setShowModalNovaOcorrencia(false)
  }
  const onBtnNovoClicked = () => {
    setShowModalNovaOcorrencia(true)
  }
  const onBtnEditClicked = ocorrencia => {
    setSelectedOcorrencia(ocorrencia)
    setShowModalAjusteSobra(true)
  }

  const renderQuantity = (sobra, quantity, bold) =>
    bold ? (
      <span style={{ fontWeight: 600 }}>{formatSobraQuantity(sobra, quantity)}</span>
    ) : (
      <span>{formatSobraQuantity(sobra, quantity)}</span>
    )

  return (
    <>
      <Btn minWidth={null} onClick={onBtnNovoClicked} style={{ marginBottom: '5px' }}>
        Novo
      </Btn>
      <DataTable
        value={ocorrencias}
        emptyMessage="Não existe ocorrência associada a esta entrega"
        paginator={true}
        rows={10}
      >
        <Column field="product_code" header="Código" style={tableCellCentered(150)} />
        <Column field="product_name" header="Produto" />
        <Column field="company_name" header="Empresa" />
        <Column
          field="reason"
          header="Motivo"
          body={sobra => {
            const { missing_reason_sigla, missing_reason_name } = sobra
            return `(${missing_reason_sigla}) ${missing_reason_name}`
          }}
        />
        <Column
          header="Qte Apurado"
          style={tableCellCentered(180)}
          body={sobra => renderQuantity(sobra, sobra.qte_leftover)}
        />
        <Column
          header="Qte Ajuste"
          style={tableCellCentered(180)}
          body={sobra => renderQuantity(sobra, sobra.qte_adjusted)}
        />
        <Column
          header="Qte Sku"
          style={tableCellCentered(180)}
          body={sobra => {
            const { qte_adjusted, qte_leftover } = sobra
            return renderQuantity(sobra, Number(qte_leftover) + Number(qte_adjusted || 0), true)
          }}
        />
        <Column
          header=""
          body={sobra => (
            <BtnIcon onClick={() => onBtnEditClicked(sobra)}>
              <FaEdit color="red" size={18} />
            </BtnIcon>
          )}
          style={{ textAlign: 'center', width: 80 }}
        />
      </DataTable>
      <ModalNovaSobra
        visible={showModalNovaOcorrencia}
        onModalClose={onModalNovaOcorrenciaClose}
        onError={onModalError}
        onSuccess={onModalNovaOcorrenciaSuccess}
        dispatch={dispatch}
        fleetId={fleetId}
        vehicleBadge={vehicleBadge}
      />
      <ModalAjusteSobra
        visible={showModalAjusteSobra}
        sobra={selectedOcorrencia}
        onModalClose={onModalAjusteSobraClose}
        onError={onModalError}
        onSuccess={onModalAjusteSobraSuccess}
        fleetId={fleetId}
      />
    </>
  )
}
